import { createContext, useContext, useMemo, type ReactNode } from 'react';

export interface UpsellProtectionConfig {
  enabled: boolean;
  featureKey?: string;
  trackingSource?: string;
  title?: string;
}

const UpsellProtectionContext = createContext<UpsellProtectionConfig>({
  enabled: false,
});

export interface UpsellProtectionProviderProps {
  enabled: boolean;
  featureKey?: string;
  trackingSource?: string;
  title?: string;
  children: ReactNode;
}

export function UpsellProtectionProvider({
  enabled,
  featureKey,
  trackingSource,
  title,
  children,
}: UpsellProtectionProviderProps): JSX.Element {
  const value = useMemo(
    () => ({ enabled, featureKey, trackingSource, title }),
    [enabled, featureKey, trackingSource, title],
  );

  return (
    <UpsellProtectionContext.Provider value={value}>
      {children}
    </UpsellProtectionContext.Provider>
  );
}

export function useUpsellProtectionConfig(): UpsellProtectionConfig {
  return useContext(UpsellProtectionContext);
}
